module.exports = __webpack_public_path__ + "static/media/DOGS-1.5c19e777.png";